import React from 'react';
import { ShoppingCartPageItemModel } from './Model';
import delIcon from './images/icon-delete.svg';
import {
  getTextStatic,
  getdivClassStatic as availabilityClassName,
} from '../../Basepage/parts/Availability';
import { PageMode } from '../../Basepage/parts/Definitions';

interface ShoppingCartItemProps {
  index: number;
  mode: PageMode;
  item: ShoppingCartPageItemModel;
  domainPrefix: string;
}
export default class ShoppingCartItem extends React.Component<ShoppingCartItemProps> {
  render() {
    {
      let className: string = this.props.index % 2 == 0 ? 'rowEven' : 'rowOdd';
      if (this.props.mode == PageMode.Mobile) {
        className = className + ' mobileSlit';
      }

      let itemCountDiv = (
        <React.Fragment>
          <input
            className="cssButton submit_button button  button_update_cart_v"
            onMouseOver={(e) => {
              let target: any = e.target;
              target.className =
                'cssButtonHover  button_update_cart_v button_update_cart_vHover';
            }}
            onMouseOut={(e) => {
              let target: any = e.target;
              target.className =
                'cssButton submit_button button  button_update_cart_v';
            }}
            type="submit"
            value=""
          />

          <input
            type="hidden"
            name="products_id[]"
            value={this.props.item.id}
          />
        </React.Fragment>
      );
      let delSnipped = (
        <a
          href={
            this.props.domainPrefix +
            '/index.php?main_page=shopping_cart&action=remove_product&product_id=' +
            this.props.item.id
          }
        >
          <img
            src={delIcon}
            alt="Löschen"
            title=" Löschen "
            width="20"
            height="21"
          />
        </a>
      );

      let productsDeliveryDate: Date | undefined = undefined;
      if (this.props.item.release_date) {
        productsDeliveryDate = new Date(
          Date.parse(this.props.item.release_date),
        );
      }

      let real_lz: number | undefined = undefined;
      if (this.props.item.real_lz != undefined) {
        try {
          real_lz = Number.parseInt(this.props.item.real_lz);
        } catch {}
      }

      return (
        <React.Fragment key={'cartItemsContainer' + this.props.index}>
          <tr
            className={className}
            key={'cartItems' + this.props.index}
            id={'cartItems' + this.props.index}
          >
            <td className="cartQuantity">
              <input
                type="text"
                name="cart_quantity[]"
                defaultValue={this.props.item.quantity}
                size={4}
              />
              {this.props.mode == PageMode.Mobile ? (
                <React.Fragment>
                  <br />
                  <div className="flex">{itemCountDiv}</div>

                  <div className="flex">{delSnipped}</div>
                </React.Fragment>
              ) : null}
            </td>
            {this.props.mode != PageMode.Mobile ? (
              <React.Fragment>
                <td className="cartQuantityUpdate">{itemCountDiv}</td>
              </React.Fragment>
            ) : null}

            <td className="cartProductDisplay">
              <a href={this.props.item.productUrl} target="_blank">
                <span id="cartImage" className="back">
                  <img
                    src={
                      'https://media.moluna.de/images/' + this.props.item.image
                    }
                    alt={this.props.item.name}
                    title={this.props.item.name}
                    width="100"
                    height="auto"
                    style={{ maxHeight: '150px' }}
                  />
                </span>
                {this.props.mode != PageMode.Mobile ? (
                  <div id="cartProdTitle">
                    <span className="cartId">{this.props.item.id}</span>

                    <span className="cartTitel">{this.props.item.name}</span>
                    <span className="cartArt">
                      {this.props.item.Kategorie}{' '}
                      {this.props.item.Medium != undefined
                        ? ' - ' + this.props.item.Medium
                        : null}
                      {this.props.item.Verlag != undefined
                        ? ' - ' + this.props.item.Verlag
                        : null}
                      -
                    </span>
                    <div className="cartVerfuegbar" id="Availability">
                      <div
                        className={availabilityClassName(
                          this.props.item.Delivery_time,
                        )}
                      >
                        <div id="verfuegbarkeit">
                          {getTextStatic(
                            this.props.item.Delivery_time,
                            productsDeliveryDate,
                            real_lz,
                          )}
                        </div>
                      </div>
                    </div>
                  </div>
                ) : null}
              </a>

              <br className="clearBoth" />
            </td>
            {this.props.mode != PageMode.Mobile ? (
              <React.Fragment>
                <td className="cartUnitDisplay">
                  {this.props.item.item_price.toFixed(2).replace('.', ',')} €
                </td>
              </React.Fragment>
            ) : null}
            <td className="cartTotalDisplay">
              {this.props.item.final_price.toFixed(2).replace('.', ',')} €
            </td>
            {this.props.mode != PageMode.Mobile ? (
              <React.Fragment>
                <td className="cartRemoveItemDisplay">{delSnipped}</td>
              </React.Fragment>
            ) : null}
          </tr>
          {this.props.mode == PageMode.Mobile ? (
            <tr
              key={'cartItemsMobile' + this.props.index}
              id={'cartItemsMobile' + this.props.index}
            >
              <td colSpan={3}>
                <div id="cartProdTitle">
                  <a href={this.props.item.productUrl} target="_blank">
                    <span className="cartTitel">{this.props.item.name}</span>
                  </a>

                  <span className="cartArt">
                    {this.props.item.id} {this.props.item.Kategorie}{' '}
                    {this.props.item.Medium != undefined
                      ? ' - ' + this.props.item.Medium
                      : null}
                    {this.props.item.Verlag != undefined
                      ? ' - ' + this.props.item.Verlag
                      : null}
                    -
                  </span>
                  <div className="cartVerfuegbar" id="Availability">
                    <div
                      className={availabilityClassName(
                        this.props.item.Delivery_time,
                      )}
                    >
                      <div id="verfuegbarkeit">
                        {getTextStatic(
                          this.props.item.Delivery_time,
                          productsDeliveryDate,
                          real_lz,
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              </td>
            </tr>
          ) : null}
        </React.Fragment>
      );
    }
  }
}
